import PropTypes from 'prop-types'
import React, { Component } from 'react'
import i18n from 'simple-react-i18n'
import Checkbox from '../../../components/forms/Checkbox'
import Job from '../../../import/dto/DtoJob'
import { DEFAULT_TIME_BEFORE_ALERT } from '../../constants/AlertConstants'
import TabSelectThreshold from './TabSelectThreshold'
import SmsModalContact from '../../../administration/components/setting/smsModal/SmsModalContact'
import { Button, Grid, Tooltip } from '@mui/material'
import { HelpOutlineOutlined } from '@mui/icons-material'
import { getSetting } from '../../../utils/SettingUtils'
import SieauParameterDto from '../../../administration/dto/SieauParameterDto'
import { connect } from 'react-redux'
import Input from '../../../components/forms/Input'
import RadioButtons from '../../../components/forms/RadioButtons'
import NumberField from '../../../components/forms/NumberField'
import SimpleDatePicker from '../../../components/forms/SimpleDatePicker'
import DtoParametrageDataType from '../../../piezometry/dto/DtoParametrageDataType'
import PiezometerStationAction from '../../../station/actions/PiezometerStationAction'
import { execByType } from '../../../utils/StationUtils'
import HydrometryAction from '../../../hydrometry/actions/HydrometryAction'
import PluviometryAction from '../../../pluviometry/actions/PluviometryAction'
import AppStore from '../../../store/AppStore'
import WaitAction from '../../../wait/WaitAction'
import { hasValue } from '../../../utils/NumberUtil'
import { exportFile } from 'utils/ExportDataUtil'
import { STATION_TYPE_NAME } from 'station/constants/StationConstants'
import ContactDto from 'referencial/components/contact/dto/ContactDto'


class JobAlert extends Component {
    state = {
        selected: [],
        emailsString: '',
        contactsIds: undefined,
        isOpenSmsModal: false,
        alertTypes: {
            alertEmail: false,
            alertSms: false,
            alertFacebook: false,
        },
        stationsStats: {},
        modePrevisionnel: false,
        referenceDate: undefined,
    }

    componentDidMount() {
        const { emailsAlert = [], contactsIds = [], parameters = [], alertTypes = [], filters = [] } = this.props.job.parameters
        const selected = parameters.reduce((acc, param) => {
            const parse = JSON.parse(param)
            const station = this.props.stations.find(s => s.id === parse.stationId) || {}
            return [
                ...acc,
                {
                    code: station.code,
                    id: parse.stationId,
                    thresholdId: parse.thresholdId,
                    typeId: parse.typeId,
                    timeLinitMissingData: parse.timeLinitMissingData,
                    predSource: parse.predSource,
                    predSerie: parse.predSerie,
                },
            ]
        }, [])
        const emailsString = emailsAlert.join(';')
        const contactsIdsFormat = contactsIds.join(';')
        const alert = alertTypes.reduce((acc, a) => ({ ...acc, [a]: true }), {})
        const modePrevisionnel = filters.length ? !!JSON.parse(filters[0]).modePrevisionnel : false
        const referenceDate = filters.length ? JSON.parse(filters[0]).referenceDate : undefined
        this.setState({ selected, emailsString, contactsIds: contactsIdsFormat, alertTypes: alert, modePrevisionnel, referenceDate })
        if (selected.some(station => !(hasValue(station.id) && hasValue(station.typeId)))) {
            this.changeJobStations(selected, modePrevisionnel, referenceDate)
        }
    }

    componentDidUpdate = prevProps => {
        if (this.props.stations.length !== prevProps.stations.length) {
            this.setState(({ selected }) => ({
                selected: selected.map(station => {
                    const stationFound = this.props.stations.find(s => s.id === station.id) || {}
                    return {
                        ...station,
                        code: stationFound.code,
                    }
                }),
            }))
        }
    }

    handleChangeEmails = emailsString => {
        this.setState({ emailsString })
        const emailsList = emailsString ? emailsString.split(';') : []
        this.props.onChangeEmails(emailsList.filter(e => e))
    }

    handleChangeStation = ({ id, code } = {}, index) => {
        if (!code) {
            const selected = this.state.selected.map((s, i) => {
                if (i === index) {
                    return { id: undefined, code: undefined, timeLinitMissingData: DEFAULT_TIME_BEFORE_ALERT }
                }
                return s
            })
            this.setState({ selected })
            this.changeJobStations(selected)
        } else {
            AppStore.dispatch(WaitAction.waitStart())
            const promiseFunc = execByType(this.props.stationType, {
                piezometry: () => PiezometerStationAction.promisePiezoMeasuresStats,
                hydrometry: () => HydrometryAction.promiseHydroStats,
                pluviometry: () => PluviometryAction.promisePluviometerMeasuresStats,
            })
            promiseFunc(id).then(stats => {
                AppStore.dispatch(WaitAction.waitStop())
                const selectedOnlyTypeId = stats.length === 1 ? { typeId: stats[0].typeId } : {}
                const stationThresholdIfOnlyTypeId = stats.length === 1 ? this.props.thresholds.filter(th => {
                    if (this.props.stationType === 'hydrometry') {
                        return th.stationId === id?.toString() && parseInt(th.dataType ?? this.props.defaultDt) === stats[0].typeId
                    }
                    return th.code === code && parseInt(th.dataType ?? this.props.defaultDt) === stats[0].typeId
                }) : []
                const selectedOnlyThreshold = stationThresholdIfOnlyTypeId.length === 1 ? { thresholdId: stationThresholdIfOnlyTypeId[0].id } : {}
                const selected = this.state.selected.map((s, i) => {
                    if (i === index) {
                        return { id, code, timeLinitMissingData: DEFAULT_TIME_BEFORE_ALERT, ...selectedOnlyTypeId, ...selectedOnlyThreshold }
                    }
                    return s
                })
                this.setState({ selected, stationsStats: { ...this.state.stationsStats, [id]: stats.map(s => ({ ...s, id: s.typeId, title: s.label })) } })
                this.changeJobStations(selected)
            })
        }
    }

    handleChange = (key, value, index) => {
        this.setState(prevState => ({
            selected: prevState.selected.map((s, i) => {
                if (i !== index) {
                    return s
                }
                if (key === 'typeId') {
                    const stationThresholdWithTypeId = this.props.thresholds.filter(th => {
                        if (this.props.stationType === 'hydrometry') {
                            return th.stationId === s?.id?.toString() && parseInt(th.dataType ?? this.props.defaultDt) === value
                        }
                        return th.code === s.code && parseInt(th.dataType ?? this.props.defaultDt) === value
                    })
                    const selectedThreshold = stationThresholdWithTypeId.length === 1 ? { thresholdId: stationThresholdWithTypeId[0].id } : { thresholdId: undefined }
                    return { ...s, typeId: value, predSource: undefined, predSerie: undefined, ...selectedThreshold }
                }
                if (key === 'predSource') {
                    return { ...s, predSource: value, predSerie: undefined }
                }
                return { ...s, [key]: value }
            }),
        }), () => this.changeJobStations(this.state.selected))
    }

    changeJobStations = (stationsSelected, modePrevisionnel = this.state.modePrevisionnel, referenceDate = this.state.referenceDate) => {
        const formattedStations = stationsSelected.filter(e => e.id).map(({ id, thresholdId, typeId, timeLinitMissingData, predSource, predSerie }) => JSON.stringify({
            stationId: id,
            thresholdId,
            typeId,
            timeLinitMissingData,
            predSource,
            predSerie,
        }))
        this.props.onChangeStation(formattedStations, { canSaveJob: !stationsSelected.some(s => !(hasValue(s.id) && hasValue(s.typeId))), modePrevisionnel, referenceDate })
    }

    handleChangeModePrevisionnel = modePrevisionnel => {
        this.setState({ modePrevisionnel })
        this.changeJobStations(this.state.selected, modePrevisionnel)
    }

    handleChangeReferenceDate = referenceDate => {
        this.setState({ referenceDate }, () => this.changeJobStations(this.state.selected))
    }

    handleDeleteStation = (_, index) => {
        const selected = this.state.selected.filter((__, i) => i !== index)
        this.setState({ selected })
        this.changeJobStations(selected)
    }

    handleDuplicateStation = (_, index) => {
        const { id, code, timeLinitMissingData } = this.state.selected[index]
        const selected = [...this.state.selected, { id, code, timeLinitMissingData }]
        this.setState({ selected })
    }

    handleChangeAlertMail = alert => {
        const alertTypes = { ...this.state.alertTypes, [alert]: !this.state.alertTypes[alert] }
        this.setState({ alertTypes, emailsString: '' })
        this.props.onChangeEmails([])
        this.props.onChangeAlertTypes(Object.keys(alertTypes).filter(a => alertTypes[a]))
    }

    handleChangeAlertSms = alert => {
        const alertTypes = { ...this.state.alertTypes, [alert]: !this.state.alertTypes[alert] }
        this.setState({ alertTypes, contactsIds: undefined })
        this.props.onChangeContactsIds(undefined)
        this.props.onChangeAlertTypes(Object.keys(alertTypes).filter(a => alertTypes[a]))
    }

    onExportData = () => {
        const exportData = this.state.selected.map(p => ({
            code: p.code,
            id: p.id,
            timeLinitMissingData: p.timeLinitMissingData,
            headers: ['code', 'id', 'timeLinitMissingData'],
        }))
        exportFile({ data: exportData, titleFile: i18n.stations })
    }

    render() {
        const addAction = this.props.isEditMode ? [{
            onClick: () => this.setState({ selected: [...this.state.selected, {}] }),
            icon: 'add_box',
            tooltip: `${i18n.addAlert}`,
            color: 'white',
        }] : []

        const nbContacts = this.props.job?.parameters?.contactsIds?.filter(cid => this.props.contacts.some(c => c.id === cid)).length ?? 0

        return (
            <>
                <Grid container alignItems={'center'} padding={'1rem'} spacing={1}>
                    <Grid size={2}>
                        <Checkbox
                            checked={this.state.modePrevisionnel}
                            label={i18n.previsionalMode}
                            onChange={this.handleChangeModePrevisionnel}
                            disabled={!this.props.isEditMode}
                        />
                    </Grid>
                    <Grid size={2}>
                        <SimpleDatePicker
                            id='alertSimulationDate'
                            label={i18n.simulationDate}
                            value={this.state.referenceDate}
                            onChange={this.handleChangeReferenceDate}
                            withHour
                            disabled={!this.props.isEditMode}
                            labelSpan={(
                                <Tooltip title={i18n.simulationDateHelp}>
                                    <HelpOutlineOutlined sx={{ fontSize: '1rem', cursor: 'help' }} />
                                </Tooltip>
                            )}
                        />
                    </Grid>
                    <Grid size={8} />
                    <Grid size={2}>
                        <Checkbox
                            checked={this.state.alertTypes.alertEmail}
                            label={i18n.emailAlert}
                            onChange={() => this.handleChangeAlertMail('alertEmail')}
                            disabled={!this.props.isEditMode}
                        />
                    </Grid>
                    <Grid size={10}>
                        {!!this.state.alertTypes.alertEmail && (
                            <Input
                                value={this.state.emailsString}
                                onChange={this.handleChangeEmails}
                                disabled={!this.props.isEditMode}
                                placeholder={i18n.emailSelection}
                            />
                        ) }
                    </Grid>
                    {hasValue(getSetting(this.props.applicationSettings, 'smsSettings')) && (
                        <>
                            <Grid size={2}>
                                <Checkbox
                                    checked={this.state.alertTypes.alertSms}
                                    label={i18n.alertSms}
                                    onChange={() => this.handleChangeAlertSms('alertSms')}
                                    disabled={!this.props.isEditMode}
                                />
                            </Grid>
                            <Grid size={9}>
                                {!!this.state.alertTypes.alertSms && (
                                    <>
                                        <Grid size={3} alignItems={'center'}>
                                            <Button
                                                onClick={() => this.setState({ isOpenSmsModal: true })}
                                                variant='contained'
                                                color='primary'
                                                disabled={!this.props.isEditMode}
                                            >
                                                {`${i18n.smsSelection} (${nbContacts})`}
                                            </Button>
                                        </Grid>
                                        <Grid size={9}>
                                            <SmsModalContact
                                                contactsIdsParameters={this.props.job.parameters.contactsIds}
                                                isOpen={this.state.isOpenSmsModal}
                                                onClose={() => this.setState({ isOpenSmsModal: false })}
                                                setContactsIdsParameters={cids => this.props.onChangeContactsIds(cids.filter(cid => this.props.contacts.some(c => c.id === cid)))}
                                            />
                                        </Grid>
                                    </>
                                )}
                            </Grid>
                        </>
                    )}
                    {!(this.props.stationType === STATION_TYPE_NAME.pluviometry) ? undefined : (
                        <>
                            <Grid size={4}>
                                <RadioButtons
                                    elements={[{ code: 'LAST_MEASURE', name: 'Dernière mesure' }, { code: 'SUM_DAY', name: 'Cumul journalier' }, { code: 'SUM_PERSO', name: 'Cumul glissant personnalisé' }]}
                                    selected={this.props.filters?.modeCumulPluvio}
                                    title='Mode de cumul pluvio'
                                    onChange={v => this.props.onChangeFilters({ modeCumulPluvio: v })}
                                    disabled={!this.props.isEditMode}
                                />
                            </Grid>
                            <Grid size={4}>
                                <NumberField
                                    value={this.props.filters?.nbHoursCumulPerso}
                                    title='Cumul de pluie glissant en Heures'
                                    onChange={v => this.props.onChangeFilters({ nbHoursCumulPerso: v })}
                                    min={1}
                                    disabled={this.props.filters?.modeCumulPluvio !== 'SUM_PERSO' || !this.props.isEditMode}
                                />
                            </Grid>
                        </>
                    )}
                </Grid>
                <div className='padding-top-1'>
                    <TabSelectThreshold
                        stations={this.props.stations}
                        dataTypes={this.props.dataTypes}
                        thresholds={this.props.thresholds}
                        stationsSelected={this.state.selected}
                        onChangeStation={this.handleChangeStation}
                        onChange={this.handleChange}
                        onDeleteStation={this.handleDeleteStation}
                        onDuplicateStation={this.handleDuplicateStation}
                        disabled={!this.props.isEditMode}
                        actions={[
                            ...addAction,
                            {
                                icon: 'file_download',
                                tooltip: i18n.export,
                                onClick: this.onExportData,
                                color: 'white',
                            },
                        ]}
                        stationType={this.props.stationType}
                        stationsStats={this.state.stationsStats}
                        modePrevisionnel={this.state.modePrevisionnel}
                    />
                </div>
            </>
        )
    }
}

JobAlert.propTypes = {
    stationType: PropTypes.string,
    onChangeFilters: PropTypes.func,
    filters: PropTypes.shape({
        modeCumulPluvio: PropTypes.string,
        nbHoursCumulPerso: PropTypes.number,
    }),
    job: PropTypes.instanceOf(Job).isRequired,
    isEditMode: PropTypes.bool,
    onChangeEmails: PropTypes.func,
    onChangeContactsIds: PropTypes.func,
    onChangeStation: PropTypes.func,
    onChangeAlertTypes: PropTypes.func,
    stations: PropTypes.arrayOf(PropTypes.shape({})),
    thresholds: PropTypes.arrayOf(PropTypes.shape({})),
    applicationSettings: PropTypes.arrayOf(PropTypes.instanceOf(SieauParameterDto)),
    dataTypes: PropTypes.arrayOf(PropTypes.instanceOf(DtoParametrageDataType)),
    defaultDt: PropTypes.string,
    contacts: PropTypes.arrayOf(PropTypes.instanceOf(ContactDto)),
}

const mapStateToProps = store => ({
    applicationSettings: store.AdministrationReducer.applicationSettings,
    contacts: store.ContactReducer.contacts,
})

export default connect(mapStateToProps)(JobAlert)